import Vue from 'vue'
import {dd,store,app} from 'systems/imports'

import BaseProcessor from 'processor/BaseProcessor'
import API from 'api/Organization'

/**
 * 運営サイト情報
 */
class Organization extends BaseProcessor{
  static getClassName(){ return 'Organization' }

  /**
   */
  static gets(input){
    return new Promise(function(resolve, reject) {
      API.gets(input)
        .then((res)=>{
          return resolve({status:"ok",data:{organizations:res.organizations} })
        }).catch((e)=>{
        switch(e.name){
        }
      })
    });
  }
}

export default Organization



// WEBPACK FOOTER //
// ./src/processor/Organization.js